import { render, staticRenderFns } from "./FlightList.vue?vue&type=template&id=7056cfe7&"
import script from "./FlightList.vue?vue&type=script&lang=js&"
export * from "./FlightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports